import { createFileRoute } from '@tanstack/react-router';
import ImageSelector from '@/components/Exercises/DrawingSVGs/ImageSelector';

export const Route = createFileRoute(
  '/(content)/adults/exercises/(shared)/drawing/mandala',
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Drawing Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "drawing.title",
    navbar: {
      showTitle: true,
    }
  }),
})

function RouteComponent() {
  return <ImageSelector />;
}
